<template><section><h3>区域海洋表层叶绿素多尺度变化模拟系统</h3>
<h4>背景介绍：</h4>
<p>浮游植物是海洋食物网的基础，其生物量通常以叶绿素a浓度表征。卫星水色遥感使表层叶绿素得以大范围、长时序连续观测，其季节变化与年际变化是检验海洋生态模型最直接、数据条件最完备的标尺，也是生态模型区域应用的第一步。以黄海为例：黄海是典型的浅水陆架海，表层叶绿素具有显著的季节循环——冬春季光照与层结配合形成高值，夏季强层结与营养盐供给限制使其维持较低水平，年际变化则与季风、径流及气候变化相联系。对选定海区的表层叶绿素开展多年回报并与卫星遥感对比，检验模型能否再现季节循环的相位与幅度以及年际距平，是评估区域生态模型可信度的基本途径。本项目的研究区域由使用者自行选择（默认示例为黄海），工作流对任一海域通用。</p>
<p>NEMURO（North Pacific Ecosystem Model for Understanding Regional Oceanography）是由北太平洋海洋科学组织多国团队共同建立的低营养级生态动力学模型，包含11个状态变量：硝酸盐、铵盐、小型与大型浮游植物、小型、大型与捕食性浮游动物、颗粒态与溶解态有机氮、硅酸与颗粒硅，以氮和硅为循环货币，生物过程速率随温度调节。模型Fortran与MATLAB程序公开，参数文档完备，结构清晰，适合作为生态建模训练与区域应用的载体。</p>
<p>哥白尼海洋环境监测服务（CMEMS）提供了统一格式的多卫星融合表层叶绿素a L4产品（GlobColour处理链）、GLORYS12V1全球物理再分析（温度、盐度、流场与混合层深度）以及全球生物地球化学再分析（营养盐等）。利用这些公开数据作为强迫与验证来源，配合公开的NEMURO程序，可以在一个学期内完成&quot;数据—模型—验证—分析&quot;的完整闭环，无需自行观测或编程实现模型方程。</p>
<p>本项目所用数据均为CMEMS公开数据集，在数据门户注册后即可免费下载，入口与产品页链接如下：</p>
<ul>
<li>CMEMS数据门户：<a href="https://data.marine.copernicus.eu">CMEMS数据门户</a>；</li>
<li>表层叶绿素验证数据（Global Ocean Colour L4 monthly，1997年至今）：<a href="https://data.marine.copernicus.eu/product/OCEANCOLOUR_GLO_BGC_L4_MY_009_104/description">Global Ocean Colour L4 monthly</a>；</li>
<li>物理再分析GLORYS12V1（强迫数据）：<a href="https://data.marine.copernicus.eu/product/GLOBAL_MULTIYEAR_PHY_001_030/description">GLORYS12V1</a>；</li>
<li>生物地球化学再分析（营养盐气候态参考）：<a href="https://data.marine.copernicus.eu/product/GLOBAL_MULTIYEAR_BGC_001_029/description">GLOBAL_MULTIYEAR_BGC</a>。</li>
</ul>
<h4>项目要求：</h4>
<ol>
<li>
<p>CMEMS数据获取与预处理</p>
<ul>
<li>编写脚本自动下载与裁剪目标海区的三类数据：多卫星融合叶绿素a月平均L4产品、GLORYS12V1温度盐度与混合层深度、生物地球化学再分析营养盐气候态场。统一时间与空间基准，形成模型输入与验证两个数据集；温跃层与混合层深度由温度剖面按标准密度差判据诊断。</li>
</ul>
</li>
<li>
<p>NEMURO程序配置与自旋起运行</p>
<ul>
<li>在原版北太平洋参数基础上，针对所选区域调整光照、温度强迫与层底营养盐常数；编译运行Fortran程序，先积分3年完成自旋起，取第4年起的多年结果作为回报时段；确认状态变量季节循环达到稳定态。</li>
</ul>
</li>
<li>
<p>表层叶绿素回报与遥感对比</p>
<ul>
<li>将模拟表层叶绿素与卫星遥感月平均产品对比，仅使用表层：报告相关系数、均方根误差、季节循环的相位与振幅、年际距平的相关性；绘制模拟与遥感的逐日/月时间序列对比图。</li>
</ul>
</li>
<li>
<p>多尺度变化分析</p>
<ul>
<li>对模拟与遥感的表层叶绿素分别开展多尺度分解：季节循环（月气候态）、年际距平与多年趋势；比较两者在各尺度上的异同，讨论季节尺度偏差对应的生物过程问题与年际尺度偏差对应的强迫问题。</li>
</ul>
</li>
<li>
<p>参数敏感性与结果解释</p>
<ul>
<li>从NEMURO的约75个参数中，结合文献筛选10—15个关键参数（最大生长率、捕食半饱和常数、沉降速率、温度敏感性参数等），在大语言模型的协助下逐一施加扰动并统计表层叶绿素的响应，输出参数重要性排序；由大语言模型辅助生成结果解释，说明关键参数对应的生态过程。</li>
</ul>
</li>
</ol>
</section></template><script>export default {components:{}}</script>